/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Check, RefreshCw, Info, X, MessageSquare, Power, Edit2, Eye, Copy } from "lucide-react";
import apicache from "../../clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationservicePageActivation({ close }) {
    const store = useSelector((state) => state.StoreReducer);
    const dispatch = useDispatch();
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const { t, i18n } = useTranslation();
    const account = useSelector((state) => state.AccountReducer);

    // Messages par défaut
    const defaultMessages = {
        1: "",
        2: "",
        3: `مرحباً {customerName},\nتم تأكيد طلبك بنجاح .🛍 المنتج: {productName}\n💰إجمالي السعر: {totalAmount} {currencySymbol}\nسيتم تجهيز طلبك وإرساله في أقرب وقت.شكرا لثقتك. لا تتردد في التواصل إذا كان لديك أي استفسارات.\nبانتظار خدمتك مجدداً،\n`,
        4: `مرحباً {customerName},\nنود أن نعلمك أنه تم رفع طلبك لشركة التوصيل \n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n  سيتصل بك الموزع خلال أيام ٫نرجو الاستعداد لاستلام المنتج والرد بسرعة. نقدر تفهمك وتعاونك، ونسعى دائمًا لخدمتك بشكل مميز`,
        5: "",
        6: ` مرحباً {customerName},\nنأسف لإبلاغك بأن طلبك قد تم إلغاؤه و السبب راجع لعدم ردك على إتصالاتنا .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n إذا كنت مهتم لا تتردد في الاتصال بنا .\nبانتظار إتصالك`,
        "11-1": ` مرحباً {customerName},\nنحن في انتظار اتصالك لتأكيد طلبك .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount}{currencySymbol}\n    نود إعلامك أن الكمية المتاحة من المنتج قد تقترب من النفاذ. ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك\nطاب يومك,`,
        "11-2": `مرحباً {customerName},\nنأسف لعدم الرد على اتصالنا السابق.\nيرجى الاتصال  بنا لتأكيد طلبك:\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\nبإنتظار تواصلك لتأكيد طلبك ،\n`,
        "11-3": ` مرحباً {customerName},\nنود إعلامك بأنه تم تأجيل طلبك:\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\nسنتواصل معك قريبا لتحديد موعد الإستلام ،\n`,
        "11-4": `مرحباً {customerName},\n لقد قمنا بمحاولة الاتصال بك لتأكيد طلبك، ولكن وجدنا خطك مغلقًا\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n   يُرجى التأكد من تفعيل الاتصال و ننتظر اتصالك في أقرب وقت لتأكيد طلبك وضمان توفر المنتج لك \n طاب يومك,`,
        "11-5": ` مرحباً {customerName},\nنأسف لإلغاء طلبك .\n-🛍 المنتج: {productName}\n- 💰إجمالي السعر: {totalAmount} {currencySymbol}\n إذا قررت طلب المنتج في وقت لاحق، فلا تتردد في الاتصال بنا. سنكون سعداء بخدمتك في المستقبل,`,
    };

    // Informations sur les statuts
    const statusInfo = {
        1: { 
            name: t("servicePageActivation.orderMessages.statuses.1.name"), 
            description: t("servicePageActivation.orderMessages.statuses.1.description"),
            icon: "📝",
            color: "grey"
        },
        2: { 
            name: t("servicePageActivation.orderMessages.statuses.2.name"), 
            description: t("servicePageActivation.orderMessages.statuses.2.description"),
            icon: "⏳",
            color: "blue"
        },
        3: { 
            name: t("servicePageActivation.orderMessages.statuses.3.name"), 
            description: t("servicePageActivation.orderMessages.statuses.3.description"),
            icon: "✅",
            color: "green"
        },
        4: { 
            name: t("servicePageActivation.orderMessages.statuses.4.name"), 
            description: t("servicePageActivation.orderMessages.statuses.4.description"),
            icon: "🚚",
            color: "purple"
        },
        5: { 
            name: t("servicePageActivation.orderMessages.statuses.5.name"), 
            description: t("servicePageActivation.orderMessages.statuses.5.description"),
            icon: "📦",
            color: "orange"
        },
        6: { 
            name: t("servicePageActivation.orderMessages.statuses.6.name"), 
            description: t("servicePageActivation.orderMessages.statuses.6.description"),
            icon: "❌",
            color: "red"
        },
        "11-1": { 
            name: t("servicePageActivation.orderMessages.statuses.11-1.name"), 
            description: t("servicePageActivation.orderMessages.statuses.11-1.description"),
            icon: "📞",
            color: "yellow"
        },
        "11-2": { 
            name: t("servicePageActivation.orderMessages.statuses.11-2.name"), 
            description: t("servicePageActivation.orderMessages.statuses.11-2.description"),
            icon: "🔄",
            color: "blue"
        },
        "11-3": { 
            name: t("servicePageActivation.orderMessages.statuses.11-3.name"), 
            description: t("servicePageActivation.orderMessages.statuses.11-3.description"),
            icon: "📅",
            color: "orange"
        },
        "11-4": { 
            name: t("servicePageActivation.orderMessages.statuses.11-4.name"), 
            description: t("servicePageActivation.orderMessages.statuses.11-4.description"),
            icon: "📵",
            color: "red"
        },
        "11-5": { 
            name: t("servicePageActivation.orderMessages.statuses.11-5.name"), 
            description: t("servicePageActivation.orderMessages.statuses.11-5.description"),
            icon: "👋",
            color: "grey"
        }
    };

    // Variables disponibles
    const availableVariables = [
        { variable: "{customerName}", description: t("servicePageActivation.orderMessages.variables.customerName") },
        { variable: "{productName}", description: t("servicePageActivation.orderMessages.variables.productName") },
        { variable: "{totalAmount}", description: t("servicePageActivation.orderMessages.variables.totalAmount") },
        { variable: "{currencySymbol}", description: t("servicePageActivation.orderMessages.variables.currencySymbol") },
        { variable: "{orderNumber}", description: t("servicePageActivation.orderMessages.variables.orderNumber") },
        { variable: "{orderDate}", description: t("servicePageActivation.orderMessages.variables.orderDate") }
    ];

    const isRTL = i18n.dir() === "rtl";

    // Initialisation depuis Firebase
    useEffect(() => {
        if (store) {
            const isEnabled = store.orderMessagesEnabled !== false;
            const savedMessages = store.orderMessages || {};

            // Fusionner les messages sauvegardés avec les défauts
            const mergedMessages = { ...defaultMessages };
            Object.keys(savedMessages).forEach(key => {
                if (savedMessages[key] !== undefined) {
                    mergedMessages[key] = savedMessages[key];
                }
            });

            setMessages(mergedMessages);
            setIsActive(isEnabled);
            setServiceEnabled(isEnabled);
        }
    }, [store]);

    const [messages, setMessages] = useState(defaultMessages);
    const [isActive, setIsActive] = useState(false);
    const [serviceEnabled, setServiceEnabled] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState("3");
    const [previewMode, setPreviewMode] = useState(false);

    const showAlert = (icon, title, text) => {
        return Swal.fire({
            icon,
            title,
            text,
            confirmButtonText: t("common.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            backdrop: `rgba(0,0,0,0.7)`,
            position: "center",
            customClass: {
                popup: "swal-popup-on-top",
                backdrop: "swal-backdrop-on-top",
                container: "swal-container-on-top",
            },
            willOpen: () => {
                document.querySelector(".swal2-container").style.zIndex = "9999999999";
            },
        });
    };

    // Sauvegarde dans Firebase
    const saveToFirebase = async (messagesData, enabled) => {
        setSaving(true);
        try {
            const updatedData = {
                ...store,
                orderMessages: messagesData,
                orderMessagesEnabled: enabled,
                orderMessagesLastUpdate: new Date().toISOString()
            };

            await saveStoreDraft(doc(db, "store", store.id), store, updatedData);
            dispatch(applyStoreDraft(store, updatedData));
            apicache(account, null);

            setSaving(false);
            return true;
        } catch (error) {
            setSaving(false);
            console.error("Error saving order messages to Firebase:", error);
            return false;
        }
    };

    // Activer/désactiver le service
    const handleToggleActivation = async () => {
        if (isActive) {
            // Désactivation
            setLoading(true);

            const result = await Swal.fire({
                title: t("servicePageActivation.orderMessages.alerts.deactivateConfirm.title"),
                text: t("servicePageActivation.orderMessages.alerts.deactivateConfirm.text"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: t("servicePageActivation.orderMessages.alerts.deactivateConfirm.confirm"),
                cancelButtonText: t("common.cancel"),
                reverseButtons: true
            });

            if (result.isConfirmed) {
                const success = await saveToFirebase({}, false);

                if (success) {
                    setMessages(defaultMessages);
                    setIsActive(false);
                    setServiceEnabled(false);

                    await showAlert(
                        "success",
                        t("servicePageActivation.orderMessages.alerts.deactivateSuccess.title"),
                        t("servicePageActivation.orderMessages.alerts.deactivateSuccess.text")
                    );
                } else {
                    await showAlert(
                        "error",
                        t("common.error"),
                        t("servicePageActivation.orderMessages.alerts.saveError")
                    );
                }
            }
            setLoading(false);
        } else {
            // Activation
            setLoading(true);

            const success = await saveToFirebase(messages, true);

            if (success) {
                setIsActive(true);
                setServiceEnabled(true);

                await showAlert(
                    "success",
                    t("servicePageActivation.orderMessages.alerts.activateSuccess.title"),
                    t("servicePageActivation.orderMessages.alerts.activateSuccess.text")
                );
            } else {
                await showAlert(
                    "error",
                    t("common.error"),
                    t("servicePageActivation.orderMessages.alerts.saveError")
                );
            }
            setLoading(false);
        }
    };

    // Mettre à jour un message
    const handleMessageChange = (status, value) => {
        setMessages(prev => ({
            ...prev,
            [status]: value
        }));
    };

    // Insérer une variable
    const insertVariable = (variable) => {
        const textarea = document.getElementById(`message-${selectedStatus}`);
        if (!textarea) return;

        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const newValue = messages[selectedStatus].substring(0, start) + 
                        variable + 
                        messages[selectedStatus].substring(end);

        handleMessageChange(selectedStatus, newValue);

        // Focus et positionner le curseur après la variable
        setTimeout(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = start + variable.length;
        }, 0);
    };

    // Prévisualisation du message
    const getPreviewMessage = () => {
        let preview = messages[selectedStatus] || "";

        // Remplacer les variables par des valeurs d'exemple
        preview = preview.replace(/{customerName}/g, "محمد أحمد");
        preview = preview.replace(/{productName}/g, "هاتف ذكي إكس برو");
        preview = preview.replace(/{totalAmount}/g, "1,250");
        preview = preview.replace(/{currencySymbol}/g, "ر.س");
        preview = preview.replace(/{orderNumber}/g, "ORD-2024-00123");
        preview = preview.replace(/{orderDate}/g, "15 ديسمبر 2024");

        // Remplacer les sauts de ligne par des <br>
        return preview.split('\n').map((line, i) => (
            <React.Fragment key={i}>
                {line}
                <br />
            </React.Fragment>
        ));
    };

    // Réinitialiser un message
    const handleResetMessage = async (status) => {
        const result = await Swal.fire({
            title: t("servicePageActivation.orderMessages.alerts.resetMessage.title"),
            text: t("servicePageActivation.orderMessages.alerts.resetMessage.text"),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#9e68ba',
            cancelButtonColor: '#6b7280',
            confirmButtonText: t("servicePageActivation.orderMessages.alerts.resetMessage.confirm"),
            cancelButtonText: t("common.cancel"),
            reverseButtons: true
        });

        if (result.isConfirmed) {
            handleMessageChange(status, defaultMessages[status]);
        }
    };

    // Réinitialiser tous les messages
    const handleResetAll = async () => {
        const result = await Swal.fire({
            title: t("servicePageActivation.orderMessages.alerts.resetAll.title"),
            text: t("servicePageActivation.orderMessages.alerts.resetAll.text"),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#9e68ba',
            cancelButtonColor: '#6b7280',
            confirmButtonText: t("servicePageActivation.orderMessages.alerts.resetAll.confirm"),
            cancelButtonText: t("common.cancel"),
            reverseButtons: true
        });

        if (result.isConfirmed) {
            setMessages(defaultMessages);

            // Si le service est actif, sauvegarder automatiquement
            if (isActive) {
                await handleSaveChanges();
            }
        }
    };

    // Copier le message
    const handleCopyMessage = () => {
        navigator.clipboard.writeText(messages[selectedStatus] || "");
        Swal.fire({
            icon: 'success',
            title: t("servicePageActivation.orderMessages.alerts.copySuccess.title"),
            text: t("servicePageActivation.orderMessages.alerts.copySuccess.text"),
            timer: 1500,
            showConfirmButton: false
        });
    };

    // Sauvegarder les changements
    const handleSaveChanges = async () => {
        setLoading(true);

        const success = await saveToFirebase(messages, true);

        if (success) {
            setIsActive(true);
            setServiceEnabled(true);

            await showAlert(
                "success",
                t("servicePageActivation.orderMessages.alerts.saveSuccess.title"),
                t("servicePageActivation.orderMessages.alerts.saveSuccess.text")
            );

            if (close) close();
        } else {
            await showAlert(
                "error",
                t("common.error"),
                t("servicePageActivation.orderMessages.alerts.saveError")
            );
        }

        setLoading(false);
    };

    // Soumettre le formulaire
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isActive) {
            await handleSaveChanges();
        } else {
            await handleToggleActivation();
        }
    };

    return (
        <div className="min-h-[400px] h-fit p-6 dark:!bg-[#181919] dark:text-gray-100 dark:!border-gray-700" dir={isRTL ? "rtl" : "ltr"}>
            {/* En-tête */}
            <div className="mb-6">
                <h1 className="text-xl font-bold text-[#9e68ba] dark:text-purple-400 mb-2">
                    {t("servicePageActivation.orderMessages.title")}
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.orderMessages.description")}
                </p>
            </div>

            {/* Statut du service */}
            <div className={`mb-6 p-4 rounded-lg ${isActive
                    ? "bg-green-50 dark:!bg-green-900/30 border border-green-200 dark:!border-green-800"
                    : "bg-gray-50 dark:!bg-gray-800/50 border border-gray-200 dark:!border-gray-700"
                }`}>
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <div className={`w-3 h-3 rounded-full mr-2 ${isActive
                                ? "bg-green-500 dark:!bg-green-400 animate-pulse"
                                : "bg-gray-400 dark:!bg-gray-500"
                            }`}></div>
                        <span className={`font-medium ${isActive
                                ? "text-green-700 dark:text-green-300"
                                : "text-gray-700 dark:text-gray-300"
                            }`}>
                            {isActive
                                ? t("servicePageActivation.orderMessages.serviceStatus.active")
                                : t("servicePageActivation.orderMessages.serviceStatus.inactive")}
                        </span>
                        {saving && (
                            <span className="text-xs text-blue-600 dark:text-blue-400 mr-3 animate-pulse">
                                {t("servicePageActivation.orderMessages.saving")}
                            </span>
                        )}
                    </div>

                    <button
                        type="button"
                        onClick={handleToggleActivation}
                        disabled={loading || saving}
                        className={`px-4 py-2 text-sm rounded-lg font-medium transition-colors flex items-center ${isActive
                                ? "bg-red-100 dark:!bg-red-900/30 text-red-700 dark:text-red-300 hover:bg-red-200 dark:hover:bg-red-800/50"
                                : "bg-green-100 dark:!bg-green-900/30 text-green-700 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-800/50"
                            } ${loading || saving ? 'opacity-50 cursor-not-allowed' : ''}`}>
                        <Power size={16} className="ml-2" />
                        {isActive
                            ? t("servicePageActivation.orderMessages.buttons.deactivate")
                            : t("servicePageActivation.orderMessages.buttons.activate")}
                    </button>
                </div>

                {isActive ? (
                    <div className="mt-3 text-sm text-green-600 dark:text-green-400">
                        <MessageSquare size={16} className="inline ml-1" />
                        {t("servicePageActivation.orderMessages.statusMessages.active")}
                    </div>
                ) : (
                    <div className="mt-3 text-sm text-gray-600 dark:text-gray-400">
                        <MessageSquare size={16} className="inline ml-1" />
                        {t("servicePageActivation.orderMessages.statusMessages.inactive")}
                    </div>
                )}
            </div>

            {/* Formulaire d'édition */}
            <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-gray-700 p-6 mb-6">
                <form onSubmit={handleSubmit}>
                    {/* Sélection du statut */}
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold text-[#9e68ba] dark:text-purple-400 mb-4">
                            {t("servicePageActivation.orderMessages.selectStatus")}
                        </h3>

                        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 mb-6">
                            {Object.keys(statusInfo).map(status => {
                                const info = statusInfo[status];
                                const isSelected = selectedStatus === status;
                                const hasMessage = messages[status] && messages[status].trim().length > 0;

                                return (
                                    <button
                                        key={status}
                                        type="button"
                                        onClick={() => setSelectedStatus(status)}
                                        className={`p-3 rounded-lg border transition-all ${isSelected
                                                ? `bg-${info.color}-100 dark:!bg-${info.color}-900/30 border-${info.color}-300 dark:!border-${info.color}-700`
                                                : "bg-gray-50 dark:!bg-gray-800 border-gray-200 dark:!border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700"
                                            }`}>
                                        <div className="flex items-center">
                                            <span className="text-lg ml-2">{info.icon}</span>
                                            <div className="text-right">
                                                <div className="font-medium text-gray-800 dark:text-gray-200">
                                                    {info.name}
                                                </div>
                                                <div className={`text-xs ${hasMessage ? 'text-green-600 dark:text-green-400' : 'text-gray-500 dark:text-gray-400'}`}>
                                                    {hasMessage 
                                                        ? t("servicePageActivation.orderMessages.hasMessage") 
                                                        : t("servicePageActivation.orderMessages.noMessage")}
                                                </div>
                                            </div>
                                        </div>
                                    </button>
                                );
                            })}
                        </div>

                        {/* Informations sur le statut sélectionné */}
                        <div className="bg-blue-50 dark:!bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:!border-blue-800/30 mb-6">
                            <div className="flex items-center mb-2">
                                <span className="text-2xl ml-2">{statusInfo[selectedStatus]?.icon}</span>
                                <h4 className="font-semibold text-blue-800 dark:text-blue-300">
                                    {statusInfo[selectedStatus]?.name}
                                </h4>
                            </div>
                            <p className="text-sm text-gray-700 dark:text-gray-300">
                                {statusInfo[selectedStatus]?.description}
                            </p>
                        </div>
                    </div>

                    {/* Édition du message */}
                    <div className="mb-6">
                        <div className="flex justify-between items-center mb-4">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-gray-200">
                                {t("servicePageActivation.orderMessages.editMessage")}
                            </h3>
                            <div className="flex gap-2">
                                <button
                                    type="button"
                                    onClick={() => setPreviewMode(!previewMode)}
                                    className="px-3 py-1.5 text-sm bg-gray-100 dark:!bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors">
                                    <Eye size={16} className="inline ml-1" />
                                    {previewMode ? t("servicePageActivation.orderMessages.buttons.edit") : t("servicePageActivation.orderMessages.buttons.preview")}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => handleResetMessage(selectedStatus)}
                                    className="px-3 py-1.5 text-sm bg-yellow-100 dark:!bg-yellow-900/30 text-yellow-700 dark:text-yellow-300 rounded-lg hover:bg-yellow-200 dark:hover:bg-yellow-800/50 transition-colors">
                                    {t("servicePageActivation.orderMessages.buttons.reset")}
                                </button>
                                <button
                                    type="button"
                                    onClick={handleCopyMessage}
                                    className="px-3 py-1.5 text-sm bg-blue-100 dark:!bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg hover:bg-blue-200 dark:hover:bg-blue-800/50 transition-colors">
                                    <Copy size={16} className="inline ml-1" />
                                    {t("servicePageActivation.orderMessages.buttons.copy")}
                                </button>
                            </div>
                        </div>

                        {/* Variables disponibles */}
                        <div className="mb-4">
                            <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                                {t("servicePageActivation.orderMessages.availableVariables")}
                            </h4>
                            <div className="flex flex-wrap gap-2 mb-4">
                                {availableVariables.map((item, index) => (
                                    <button
                                        key={index}
                                        type="button"
                                        onClick={() => insertVariable(item.variable)}
                                        className="px-3 py-1.5 text-sm bg-purple-100 dark:!bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-lg hover:bg-purple-200 dark:hover:bg-purple-800/50 transition-colors">
                                        {item.variable}
                                        <span className="text-xs text-gray-500 dark:text-gray-400 mr-1">
                                            ({item.description})
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Zone d'édition/Prévisualisation */}
                        {previewMode ? (
                            <div className="border border-gray-200 dark:!border-gray-700 rounded-lg p-4 bg-gray-50 dark:!bg-gray-800 min-h-[200px] whitespace-pre-wrap">
                                {getPreviewMessage()}
                            </div>
                        ) : (
                            <textarea
                                id={`message-${selectedStatus}`}
                                value={messages[selectedStatus] || ""}
                                onChange={(e) => handleMessageChange(selectedStatus, e.target.value)}
                                placeholder={t("servicePageActivation.orderMessages.messagePlaceholder")}
                                className="w-full h-64 px-4 py-3 border border-gray-300 dark:!border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:focus:ring-purple-400 focus:border-transparent outline-none transition bg-white dark:!bg-gray-700 text-gray-900 dark:text-gray-100 resize-none"
                                dir="rtl"
                                disabled={loading || saving}
                            />
                        )}

                        {/* Compteur de caractères */}
                        <div className="mt-2 text-right">
                            <span className={`text-sm ${(messages[selectedStatus] || "").length > 500 ? 'text-red-600' : 'text-gray-500'}`}>
                                {(messages[selectedStatus] || "").length} / 1000 {t("servicePageActivation.orderMessages.characters")}
                            </span>
                        </div>
                    </div>

                    {/* Conseils */}
                    <div className="bg-yellow-50 dark:!bg-yellow-900/20 p-4 rounded-lg border border-yellow-200 dark:!border-yellow-800/30 mb-6">
                        <h4 className="font-medium text-lg text-yellow-800 dark:text-yellow-300 mb-2 flex items-center">
                            <Info size={18} className="ml-2" />
                            {t("servicePageActivation.orderMessages.tips.title")}
                        </h4>
                        <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                            <li className="flex items-start">
                                <span className="text-yellow-600 dark:text-yellow-400 ml-2">•</span>
                                {t("servicePageActivation.orderMessages.tips.personalization")}
                            </li>
                            <li className="flex items-start">
                                <span className="text-yellow-600 dark:text-yellow-400 ml-2">•</span>
                                {t("servicePageActivation.orderMessages.tips.clarity")}
                            </li>
                            <li className="flex items-start">
                                <span className="text-yellow-600 dark:text-yellow-400 ml-2">•</span>
                                {t("servicePageActivation.orderMessages.tips.contactInfo")}
                            </li>
                            <li className="flex items-start">
                                <span className="text-yellow-600 dark:text-yellow-400 ml-2">•</span>
                                {t("servicePageActivation.orderMessages.tips.test")}
                            </li>
                        </ul>
                    </div>

                    {/* Boutons d'action */}
                    <div className="flex justify-between gap-3">
                        <div className="flex gap-3">
                            <button
                                type="button"
                                onClick={handleResetAll}
                                disabled={loading || saving}
                                className="px-4 py-2.5 border border-gray-300 dark:!border-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                                {t("servicePageActivation.orderMessages.buttons.resetAll")}
                            </button>
                        </div>

                        <button
                            type="submit"
                            disabled={loading || saving}
                            className={`px-6 py-2.5 ${isActive
                                    ? "bg-[#9e68ba] dark:!bg-purple-600 hover:bg-[#8a5ca5] dark:hover:bg-purple-700"
                                    : "bg-green-600 dark:!bg-green-700 hover:bg-green-700 dark:hover:bg-green-600"
                                } text-white font-medium rounded-lg transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed`}>
                            {loading || saving ? (
                                <>
                                    <RefreshCw className="animate-spin ml-2" size={18} />
                                    {saving ? t("servicePageActivation.orderMessages.saving") : t("servicePageActivation.orderMessages.processing")}
                                </>
                            ) : (
                                <>
                                    <Check className="ml-2" size={18} />
                                    {isActive ? t("servicePageActivation.orderMessages.buttons.save") : t("servicePageActivation.orderMessages.buttons.activate")}
                                </>
                            )}
                        </button>
                    </div>
                </form>
            </div>

            {/* Informations de mise à jour */}
            <div className="text-xs text-gray-500 dark:text-gray-400 text-center">
                {store?.orderMessagesLastUpdate && (
                    <p>
                        {t("servicePageActivation.orderMessages.lastUpdate")} {new Date(store.orderMessagesLastUpdate).toLocaleString('fr-FR')}
                    </p>
                )}
            </div>
        </div>
    );
}